import { render, staticRenderFns } from "./NoPhoto.vue?vue&type=template&id=2c935fb3"
import script from "./NoPhoto.vue?vue&type=script&lang=js"
export * from "./NoPhoto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports